import { render, staticRenderFns } from "./custom-server.vue?vue&type=template&id=3d094a5c&scoped=true"
import script from "./custom-server.vue?vue&type=script&lang=js"
export * from "./custom-server.vue?vue&type=script&lang=js"
import style0 from "./custom-server.vue?vue&type=style&index=0&id=3d094a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d094a5c",
  null
  
)

export default component.exports